import styled from 'styled-components';
import { normalize } from 'utils/styles';
import { color, typography } from 'styles/settings';

export const Image = styled.img`
  width: ${normalize('50px')};
  height: ${normalize('50px')};
  border-radius: ${normalize('50px')};
`;

export const NoAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${normalize('50px')};
  height: ${normalize('50px')};
  border-radius: ${normalize('50px')};

  background-color: ${color.neutral.grayLight};
  color: ${color.neutral.plainBlack};
  ${typography.font.title.bold};
`;
